module.exports = __webpack_public_path__ + "img/layout_bottom_3.f20e0bb7.jpg";